// extracted by mini-css-extract-plugin
export default {"container":"CustomDrawer_container__y9Bi+","customDrawerPaper":"CustomDrawer_customDrawerPaper__Rpm-L"};